import React from 'react';
import PropTypes from 'prop-types';

/**
 * A flag used to illustrate a currency
 */
const Flag = (props) => {
    const iconURL = `url(${process.env.PUBLIC_URL}/Images/Flags/flag_${props.name.toLowerCase()}.svg)`;
    // because the flags can have different sizes we use a `background-image` for easier positioning and scaling
    return (
        <div className="flag" style={{backgroundImage: iconURL}}></div>
    )
};
 
Flag.propTypes = {
    name: PropTypes.string.isRequired
};

export default Flag;